import LayoutWebContainer from "./LayoutWebContainer";
import LayoutWebStore from "./LayoutWebStore";

export default LayoutWebStore(LayoutWebContainer);